import React from 'react';
import { Button, Alert, Container } from 'react-bootstrap';
import { signOut } from 'firebase/auth';
import { useAuth } from '../contexts/authContext';
import { auth } from '../firebase';
import { Link, useNavigate } from 'react-router-dom';
import { ImageProvider } from '../contexts/imageContext';
import UploadAbout from './dashboard/uploadAbout';
import UploadFeaturedImage from './dashboard/uploadFeaturedImage';
import UploadOtherProject from './dashboard/uploadOtherproject';
import UploadInfo from './dashboard/uploadInfo';

export default function Dashboard() {
    const currentUser = useAuth()
    const navigate = useNavigate()
    const logout = async(e)=>{
        e.preventDefault()
        await signOut(auth)
        navigate("/")
    }
  return (
    <ImageProvider>
        <Container>
            <Link to={"/"} className="h3">Home</Link>
            <header className='d-flex py-4 justify-content-between align-items-center'>
                <h3>Admin Dashboard</h3>
                <Button variant="danger" onClick={logout}>Log Out</Button>
            </header>
            {currentUser && <Alert variant='success'>{currentUser.email} is currently Logged in</Alert>}

            <UploadAbout></UploadAbout>
            <UploadFeaturedImage></UploadFeaturedImage>
            <UploadOtherProject></UploadOtherProject>
            <UploadInfo></UploadInfo>
        </Container>
    </ImageProvider>
  )
}
